export class TRPCTimeoutError extends Error {
  public readonly url: URL | RequestInfo;
  public readonly status: number;

  constructor({
    url,
    status,
  }: {
    url: URL | RequestInfo;
    status: number;
  }) {
    super(`Request timed out (status ${status})`);
    this.name = "TRPCTimeoutError";
    this.url = url;
    this.status = status;
  }
}
